import { ISelectorOption } from "types/ISelectorOption";

export const formatAddonsPersonsRange = (min: number, max: number): ISelectorOption<number>[] =>
  Array.from({ length: max - min + 1 }, ((_element, index) => (
    { label: `${index + min}`, value: index + min })));

